import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { registerSW } from "./push";

registerSW();

// Sopprime gli overlay di errore "Uncaught runtime errors" del server di sviluppo
// (compaiono SOLO nell'anteprima/preview, mai nell'app pubblicata/deployata).
const _roMsg = /ResizeObserver loop (limit exceeded|completed)/;
const _hideDevOverlay = () => {
  document.querySelectorAll("iframe").forEach((f) => {
    try { if (f.style && f.style.zIndex === "2147483647") f.remove(); } catch (_) {}
  });
};
window.addEventListener("error", (e) => {
  if (e?.message && _roMsg.test(e.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
  setTimeout(_hideDevOverlay, 0);
});
window.addEventListener("unhandledrejection", (e) => {
  // le promise non gestite (di solito chiamate di rete fallite) non devono bloccare la UI
  e.preventDefault();
  setTimeout(_hideDevOverlay, 0);
});

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
